import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import { Trans } from "react-i18next";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form, Table, Modal } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../../environment.js";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Toggle from "react-toggle";
import "../PartnerScreens/Shipment.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link, useHistory } from "react-router-dom";
import NavbarNew from "../../Components/NavbarNew.js";

const MySwal = withReactContent(Swal);

const { SearchBar } = Search;

const ReturnShipmentDetails = ({ history, match, props }) => {
  const [show, setShow] = useState(false);
  const [showdevices, setShowDevices] = useState(false);
  const [DocketNo, setDocketNo] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState({});
  const [shipmentLogs, setShipmentLogs] = useState([]);
  const [devicedeials, setDeviceDetails] = useState([]);
  const [consignordetails, setConsignorDetails] = useState({});
  const [createdbyLogisticManager, setcreatedbyManager] = useState(false);
  const [toggleChecked, setToggleChecked] = useState(false);
  const [partnerdetails, setPartnerDetails] = useState({});
  const [status, setStatus] = useState();
  const [devices, setDevices] = useState([]);
  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
  };
  const handleShowDevices = (key, val, e) => {
    console.log(val);
    setDevices(val);
    setShowDevices(true);
  };

  const handleCloseDevices = () => {
    setShowDevices(false);
  };
  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   axios
  //     .put(
  //       environment.dap_url +
  //         "shipmentApi/updateShipmentStatus?_id=" +
  //         match.params.id,
  //       {
  //         status: status,
  //         statusBefore: shipmentDetails.status,
  //         notes: "abc",
  //       }
  //     )
  //     .then((res) => {
  //       MySwal.fire({
  //         title: <p>Status Changed Successfully</p>,
  //         type: "success",
  //       });
  //     })
  //     .catch((err) => {
  //       MySwal.fire({
  //         title: <p>Unable to change the status</p>,
  //         type: "error",
  //       });
  //     });
  // };
  // const ChangeStatus = (e) => {
  //   setStatus(e.value);
  //   // setStatus(status);
  // };

  useEffect(() => {
    let id = match.params.id;
    getShipmentData(id);
  }, []);

  const Approve = () => {
    let id = match.params.id;
    axios
      .get(
        environment.dap_url +
          "shipmentApi/approveRejectShipment?newStatus=3&shipmentId=" +
          id
      )
      .then((res) => {
        MySwal.fire({
          title: <p>Shipment Has been Approved</p>,
          type: "success",
        });

        getShipmentData(id);
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>Unable To Approve the Shipment</p>,
          type: "success",
        });
      });
  };
  const Reject = () => {
    let id = match.params.id;
    axios
      .get(
        environment.dap_url +
          "shipmentApi/approveRejectShipment?newStatus=4&shipmentId=" +
          id
      )
      .then((res) => {
        removeShipmentStatus(id);
        MySwal.fire({
          title: <p>Shipment Has been Rejected</p>,
          type: "success",
        });
        getShipmentData(id);
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>Unable To Approve the Shipment</p>,
          type: "success",
        });
      });
  };

  const removeShipmentStatus = (dataField) => {
    axios
      .get(environment.dap_url + "shipmentApi/getByIdWithLogs?_id=" + dataField)
      .then((res) => {
        console.log(res.data.shipmentDetails[0].shipmenboxes);
        const myData = res.data.shipmentDetails[0].shipmenboxes;

        let myArray = [];
        myData.forEach((myBox) =>
          myBox.shipmentDevices.forEach((myDevice) =>
            axios
              .put(
                environment.dap_url +
                  "devices/updateShipment?deviceId=" +
                  myDevice.deviceIdMongo,
                { inShipment: false }
              )
              .then((resp) => {
                console.log(resp.data);
              })
              .catch((err) => {
                console.log(err);
              })
          )
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const finalise = () => {
    axios
      .get(
        environment.dap_url +
          "shipmentApi/finalizeShipment?shipmentId=" +
          match.params.id
      )
      .then((res) => {
        axios
          .get(
            environment.dap_url +
              "shipmentApi/approveRejectShipment?newStatus=3&shipmentId=" +
              match.params.id
          )
          .then((res) => {
            MySwal.fire({
              title: <p>Shipment has been Finalised</p>,
              type: "success",
            });
            getShipmentData(match.params.id);
          })
          .catch((err) => {
            MySwal.fire({
              title: <p>Unable To Finalize the Shipment</p>,
              type: "success",
            });
          });
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>Something went Wrong</p>,
          type: "success",
        });
      });
  };

  const toggle = (e) => {
    MySwal.fire({
      title: <p>Successfully Received the Box</p>,
      type: "success",
    });
    setToggleChecked(true);
  };
  const getShipmentData = (id) => {
    axios
      .get(environment.dap_url + "shipmentApi/getByIdWithLogs?_id=" + id)
      .then((res) => {
        console.log("ankit");
        // console.log(res.data.status);
        setStatus(res.data.shipmentDetails[0].status);
        setShipmentDetails(res.data.shipmentDetails[0]);
        setDeviceDetails(res.data.shipmentDetails[0].shipmenboxes);
        setShipmentLogs(res.data.shipmentLogs);
        setConsignorDetails(res.data.shipmentDetails[0].consignordetails[0]);
        setPartnerDetails(res.data.shipmentDetails[0].consigneedetails[0]);
        if (res.data.shipmentDetails[0].hasOwnProperty("logisticId")) {
          setcreatedbyManager(true);
        }
        // if (res.data.shipmentDetails[0].status == 1) {
        //   button = <span class="label label-info">In Transition</span>;
        // }
      })
      .catch((err) => {});
  };

  const EnterDocket = () => {
    setShow(false);
    window.location.reload();
    axios
      .post(
        environment.dap_url +
          "shipmentApi/addDocketNo?shipmentId=" +
          match.params.id,
        {
          docketNo: DocketNo,
        }
      )
      .then((res) => {
        getShipmentData(match.params.id);
        setShow(false);
      })
      .catch((err) => {});
  };

  const ViewDevices = () => {
    alert();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Docket No.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Docket No.</Form.Label>
            <Form.Control
              type="text"
              //value={deviceData.accessToken}
              placeholder="Docket No."
              onChange={(e) => setDocketNo(e.target.value)}
            ></Form.Control>
            {/* <div>
              {Object.keys(nameErrors).map((key) => {
                return <div style={{ color: "red" }}>{nameErrors[key]}</div>;
              })}
            </div> */}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={EnterDocket}
            disabled={DocketNo.trim().length == 0}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showdevices} onHide={handleCloseDevices}>
        <Modal.Header closeButton>
          <Modal.Title>Box Assets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Device Category</th>
                <th scope="col">Device Label</th>
                <th scope="col">Device Version</th>
              </tr>
            </thead>
            <tbody>
              {devices?.map((val, key) => {
                return (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{val.deviceType}</td>
                    <td>{val.deviceLabel}</td>
                    <td>{val.deviceVersion}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseDevices}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="container-fluid">
        <NavbarNew />

        <Link
          to="/returnShipment"
          className="btn btn-light my-3"
          style={{ marginLeft: 0 }}
        >
          Go Back
        </Link>
        {status == 0 ? (
          <Button
            variant="light"
            className="btn btn-light"
            style={{ marginTop: 16, height: 33 }}
            onClick={finalise}
          >
            Finalise
          </Button>
        ) : status == 1 ? (
          <div className="row">
            <Button
              variant="light"
              className="btn btn-light "
              style={{
                marginTop: 16,
                marginLeft: 20,
                height: 33,
                color: "rgb(0, 117, 29)",
              }}
              onClick={Approve}
            >
              Approve
            </Button>
            <Button
              variant="light"
              className="btn btn-light "
              style={{
                marginTop: 16,
                marginLeft: 5,
                height: 33,
                color: "rgb(212, 0, 0)",
              }}
              onClick={Reject}
            >
              Reject
            </Button>
          </div>
        ) : status == 3 ? (
          <Button
            variant="light"
            className="btn btn-light"
            style={{ marginTop: 16, height: 33 }}
            onClick={handleShow}
          >
            Enter Docket No.
          </Button>
        ) : (
          ""
        )}
      </div>
      <div className="container-fluid">
        <h4>Return Shipment Details</h4>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th width="50%" scope="row">
                Country
              </th>
              <td>{shipmentDetails.consignmentCountry}</td>
            </tr>
            <tr>
              <th scope="row">State</th>
              <td>{shipmentDetails.consignmentState}</td>
            </tr>
            <tr>
              <th scope="row">City</th>
              <td>{shipmentDetails.consignmentCity}</td>
            </tr>
            <tr>
              <th scope="row">Phone</th>
              <td>{shipmentDetails.phone}</td>
            </tr>
            <tr>
              <th scope="row">Carton No.</th>
              <td>{shipmentDetails.cartonQr}</td>
            </tr>
            {shipmentDetails.docketNo && (
              <tr>
                <th scope="row">Docket No.</th>
                <td>{shipmentDetails.docketNo}</td>
              </tr>
            )}
            <tr>
              <th scope="row">Reason</th>
              <td>{shipmentDetails.Reason}</td>
            </tr>
            <tr>
              <th scope="row">Address</th>
              <td>{shipmentDetails.address}</td>
            </tr>
            <tr>
              <th scope="row">Zip Code</th>
              <td>{shipmentDetails.zip}</td>
            </tr>
            <tr>
              <th scope="row">Status</th>
              <td>
                {/* {(() => {
                          switch (shipmentDetails.status) {
                            case 0:
                              return "Intialized";
                            case 1:
                              return "In transit";
                            case 2:
                              return "Received";
                            case 3:
                              return "Completed";
                            default:
                              return "#FFFFFF";
                          }
                        })()} */}
                {shipmentDetails.status == 0 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{ backgroundColor: "#6867AC" }}
                  >
                    Initalized
                  </button>
                ) : shipmentDetails.status == 1 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#59a9eb",
                      borderColor: "#59a9eb",
                    }}
                  >
                    Finalized
                  </button>
                ) : shipmentDetails.status == 5 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    In - Transit
                  </button>
                ) : shipmentDetails.status == 3 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    Approved
                  </button>
                ) : shipmentDetails.status == 4 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    Rejected
                  </button>
                ) : shipmentDetails.status == 6 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    shipment received
                  </button>
                ) : shipmentDetails.status == 7 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    All Boxes Received
                  </button>
                ) : shipmentDetails.status == 8 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    All device Installed
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "2%" }} className="container-fluid">
        <h4>Admin Details</h4>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th width="50%" scope="row">
                Name
              </th>
              <td>
                {partnerdetails.userFirstName +
                  " " +
                  partnerdetails.userLastName}
              </td>
            </tr>
            <tr>
              <th scope="row">Organization</th>
              <td>{partnerdetails.organization}</td>
            </tr>
            <tr>
              <th scope="row">Phone No.</th>
              <td>{partnerdetails.phone}</td>
            </tr>
            <tr>
              <th scope="row">Email</th>
              <td>{partnerdetails.email}</td>
            </tr>
            <tr>
              <th scope="row">Address</th>
              <td>{partnerdetails.address}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* <div style={{ marginTop: "2%" }} className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h4>Consignor Details</h4>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th width="50%" scope="row">
                        Name
                      </th>
                      <td>
                        {consignordetails.userFirstName +
                          " " +
                          consignordetails.userLastName}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>{consignordetails.email}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div style={{ marginTop: "2%" }} className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h4>Boxes</h4>
                <Table striped>
                  <thead>
                    <tr>
                      <th id="bx">Box No.</th>
                      <th>Box Label</th>
                      <th>Box Type</th>
                      <th>Is Received</th>
                      <th>Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devicedeials?.map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{val.boxQr}</td>
                          <td>{val.boxType}</td>
                          {/* <td>{val.shipmentDevices}</td> */}
                          <td>
                            <Toggle
                              id="cheese-status"
                              checked={val.isBoxReceived}
                              // value={val.deviceIdMongo}
                              disabled={true}
                            />
                            <label htmlFor="cheese-status"></label>
                          </td>
                          <td>
                            <Button
                              variant="primary"
                              className="btn btn-sm"
                              onClick={(e) =>
                                handleShowDevices(key, val.shipmentDevices, e)
                              }
                            >
                              View
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnShipmentDetails;
